var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseSecure',{attrs:{"idp":[_vm.IDP.IDIR, _vm.IDP.BCEIDBUSINESS]}},[_c('ExportSubmissions',{attrs:{"formId":_vm.f}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }